<template>
    <PlaygroundInputSelect v-for="config in selectConfigs" :key="config.uniqueKey" :config="config" />
</template>

<script setup lang="ts">
// import type { Option } from '@/stores/store-interfaces';
import { ref, type Ref } from 'vue';
import type { Option } from '@/stores/store-interfaces';
import PlaygroundInputSelect from '@/views/playground-input-select.vue';


const defaults = {
    withPortalContainer: false,
    label: 'Select example',
    placeholder: 'Select an option',
    required: false,
    uniqueKey: 1,
    options: [
        { value: 1, label: 'Option 1' },
        { value: 2, label: 'Option 2', disabled: true },
        { value: 3, label: 'Option 3' },
        { value: 4, label: 'Option 4' },
        { value: '', label: 'Label but no value' },
        { value: 5, label: 'Option 5' },
        { value: 6, label: 'Option 6' },
        { value: 7, label: 'Option 7' },
        { value: 8, label: 'Option 8' },
        { value: 9, label: 'Option 9' },
        { value: 10, label: 'Option 10' },
        { value: 11, label: 'Option 11' },
    ],
    // selected: ref([]),
    alignBottom: false,
    disabled: false,
    multiselect: false,
    errorMessage: undefined as string | undefined,

    // update: function (event: any) {
    // TODO update function
    //     console.log('update pl', event);
    // },
    // TODO: errorMessage
    // TODO: emptyable
};

export type PlayGroundInputSelectConfig = typeof defaults & { selected: Ref<Option[]> };

const selectConfigs: PlayGroundInputSelectConfig[] = [
    {
        ...defaults,
        selected: ref<Option[]>([{ value: '', label: 'Label but no value' }]),
        uniqueKey: 2,

        withPortalContainer: true,
        label: 'Example inside modal',
    },
    {
        ...defaults,
        selected: ref([]),
        uniqueKey: 3,

        label: 'Example inside modal, bottom',
        withPortalContainer: true,
        alignBottom: true,
    },
    {
        ...defaults,
        selected: ref([]),
        uniqueKey: 4,

        label: 'Window',
    },
    {
        ...defaults,
        selected: ref([]),
        uniqueKey: 5,

        label: 'Disabled',
        disabled: true,
    },
    {
        ...defaults,
        selected: ref([]),
        uniqueKey: 6,

        label: 'Required',
        required: true,
    },
    {
        ...defaults,
        selected: ref([]),
        uniqueKey: 7,

        label: 'With error message',
        errorMessage: 'This field is required',
        required: true,
    },
    {
        ...defaults,
        selected: ref([]),
        uniqueKey: 8,

        label: 'Multiselect',

        multiselect: true,
    },
];
</script>

<style scoped></style>
